module.exports = __webpack_public_path__ + "images/emoji/seedling.ad2a2ef6df2a5394f9ce.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/seedling.png
// module id = KECW
// module chunks = 24